<template>
  <div v-if="images.length > 0" class="bulletin-gallery">
    <div v-for="image in images" :key="image.id" class="bulletin-gallery-image" v-on:click="openPreview(image)">
      <img :src="getImageViewUrl(image)" :alt="image.description" class="image" />
    </div>

    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false" @ok="previewVisible = false"
             width="80%" style="user-select: none;">
      <div v-if="images.length > 1" class="navigation">
        <a-icon type="arrow-left" @click="previousPreviewImage(previewImage)" />
        <a-icon type="arrow-right" @click="nextPreviewImage(previewImage)" />
      </div>

      <img v-if="previewImage" alt="Előnézet" style="width: 100%;" :src="getImageViewUrl(previewImage, 1920)" />

    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  props: {
    id: Number
  },
  mounted() {
    this.fetchImages();
  },
  data() {
    return {
      loading: false,
      images: [],
      previewVisible: false,
      previewImage: null
    }
  },
  methods: {
    getImageViewUrl(image, width) {
      if (!width) {
        width = 320;
      }

      return '/api/v1/companies/1/images/' + image.id + '/view/?width=' + width
    },

    openPreview(image) {
      this.previewImage = image;
      this.previewVisible = true;
    },

    nextPreviewImage(image) {
      const currentIndex = this.images.indexOf(image);
      const nextImage = this.images[currentIndex + 1];

      if (nextImage) {
        this.openPreview(nextImage);
      } else {
        this.openPreview(this.images[0]);
      }
    },

    previousPreviewImage(image) {
      const currentIndex = this.images.indexOf(image);
      const previousImage = this.images[currentIndex - 1];

      if (previousImage) {
        this.openPreview(previousImage);
      } else {
        this.openPreview(this.images[this.images.length - 1]);
      }
    },

    fetchImages() {
      this.loading = true;
      return new Promise((resolve) => {
        axios.get(
            '/api/v1/companies/1/galleries/' + this.id + '/images'
        ).then((response) => {
          if (response.status !== 200) {
            throw new Error("Failed to fetch images");
          }

          this.images = response.data;

          resolve(this.images);

          this.loading = false;
        }).catch(() => {
          this.loading = true;
          this.$message.error(
              'A galéria betöltése sikertelen!'
          );
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.bulletin-gallery {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.bulletin-gallery-image {
  aspect-ratio: 16 / 9;
  overflow: hidden;
  cursor: pointer;
  border-radius: 4px;
  max-width: 308px;
}

.bulletin-gallery-image img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  user-select: none;
}

.navigation {
  margin-top: 24px;
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
}
</style>